(function () {
  "use strict";

  var CONFIG = {
    restorePath: "/cart?section_id=sc-restore-v3",
    workerUrl: "https://api.buybookbook.xyz/share"
  };

  function ensureModal() {
    var existing = document.getElementById("bbb-share-cart-modal");
    if (existing) return existing;

    var modal = document.createElement("div");
    modal.id = "bbb-share-cart-modal";
    modal.className = "bbb-share-cart-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML =
      '<div class="bbb-share-cart-modal__dialog" role="dialog" aria-modal="true" aria-label="Share cart link">' +
      '  <button type="button" class="bbb-share-cart-modal__close" data-action="close">x</button>' +
      '  <h3 class="bbb-share-cart-modal__title">Share Link</h3>' +
      '  <p class="bbb-share-cart-modal__note">Free gifts, notes, and ETA messages may not be included in this link.</p>' +
      '  <input id="bbb-share-cart-link" class="bbb-share-cart-modal__input" type="text" readonly />' +
      '  <button type="button" class="bbb-share-cart-modal__copy" data-action="copy">Copy Link</button>' +
      "  <p class=\"bbb-share-cart-modal__status\" aria-live=\"polite\"></p>" +
      "</div>";

    document.body.appendChild(modal);
    modal.addEventListener("click", function (event) {
      if (event.target === modal || event.target.getAttribute("data-action") === "close") {
        hideModal();
      }
    });

    modal.querySelector('[data-action="copy"]').addEventListener("click", function () {
      var input = modal.querySelector("#bbb-share-cart-link");
      copyText(input.value, modal.querySelector(".bbb-share-cart-modal__status"));
    });

    return modal;
  }

  function showModal(link) {
    var modal = ensureModal();
    var input = modal.querySelector("#bbb-share-cart-link");
    var status = modal.querySelector(".bbb-share-cart-modal__status");
    input.value = link;
    status.textContent = "";
    modal.setAttribute("aria-hidden", "false");
  }

  function hideModal() {
    var modal = document.getElementById("bbb-share-cart-modal");
    if (!modal) return;
    modal.setAttribute("aria-hidden", "true");
  }

  function setOverlayVisible(visible) {
    var overlay = document.getElementById("bbb-share-cart-overlay");
    if (!overlay) return;
    overlay.style.display = visible ? "flex" : "none";
  }

  function copyText(text, statusEl) {
    if (!text) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        statusEl.textContent = "Link copied.";
      }).catch(function () {
        fallbackCopy(text, statusEl);
      });
      return;
    }

    fallbackCopy(text, statusEl);
  }

  function fallbackCopy(text, statusEl) {
    var temp = document.createElement("textarea");
    temp.value = text;
    temp.setAttribute("readonly", "");
    temp.style.position = "absolute";
    temp.style.left = "-9999px";
    document.body.appendChild(temp);
    temp.select();
    document.execCommand("copy");
    document.body.removeChild(temp);
    statusEl.textContent = "Link copied.";
  }

  function normalizeCartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.map(function (item) {
      var properties = Object.assign({}, item.properties || {});
      properties._sc_title = item.title;

      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: properties
      };
    });
  }

  function toggleButtonState(button, disabled, text) {
    button.disabled = disabled;
    if (text) button.textContent = text;
  }

  function generateShareLink(button) {
    var originalLabel = button.getAttribute("data-original-label") || button.textContent;
    button.setAttribute("data-original-label", originalLabel);

    toggleButtonState(button, true, "Generating...");
    setOverlayVisible(true);

    fetch("/cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = normalizeCartItems(cart);
        if (items.length === 0) throw new Error("EMPTY_CART");

        return fetch(CONFIG.workerUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (payload) {
        var token = payload && (payload.token || (payload.data && payload.data.token));
        if (!token) throw new Error("TOKEN_NOT_RETURNED");

        var separator = CONFIG.restorePath.indexOf("?") === -1 ? "?" : "&";
        var finalLink = window.location.origin + CONFIG.restorePath + separator + "share_token=" + encodeURIComponent(token);
        showModal(finalLink);
      })
      .catch(function (error) {
        if (error && error.message === "EMPTY_CART") {
          window.alert("Your cart is empty.");
          return;
        }
        console.error("[BBB Share Cart]", error);
        window.alert("Unable to generate share cart link right now.");
      })
      .finally(function () {
        setOverlayVisible(false);
        toggleButtonState(button, false, originalLabel);
      });
  }

  function closeCartMoreMenus(exceptRoot) {
    document.querySelectorAll("[data-bbb-cart-more]").forEach(function (root) {
      if (root === exceptRoot) return;

      var trigger = root.querySelector("[data-bbb-cart-more-trigger]");
      var menu = root.querySelector("[data-bbb-cart-more-menu]");
      var confirm = root.querySelector("[data-bbb-clear-confirm]");

      if (trigger) trigger.setAttribute("aria-expanded", "false");
      if (menu) menu.hidden = true;
      if (confirm) confirm.hidden = true;
    });
  }

  function bindCartMoreMenus() {
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-bbb-cart-more-trigger]");
      if (trigger) {
        var root = trigger.closest("[data-bbb-cart-more]");
        var menu = root && root.querySelector("[data-bbb-cart-more-menu]");
        if (!menu) return;

        event.preventDefault();
        var willOpen = menu.hidden;
        closeCartMoreMenus(root);
        menu.hidden = !willOpen;
        trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
        return;
      }

      var clearButton = event.target.closest("[data-bbb-clear-cart]");
      if (clearButton) {
        var clearRoot = clearButton.closest("[data-bbb-cart-more]");
        var confirm = clearRoot && clearRoot.querySelector("[data-bbb-clear-confirm]");
        if (!confirm) return;

        event.preventDefault();
        confirm.hidden = false;
        return;
      }

      var noButton = event.target.closest("[data-bbb-clear-no]");
      if (noButton) {
        var noRoot = noButton.closest("[data-bbb-cart-more]");
        var noConfirm = noRoot && noRoot.querySelector("[data-bbb-clear-confirm]");

        event.preventDefault();
        if (noConfirm) noConfirm.hidden = true;
        return;
      }

      var yesButton = event.target.closest("[data-bbb-clear-yes]");
      if (yesButton) {
        event.preventDefault();
        yesButton.disabled = true;

        fetch("/cart/clear.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" }
        }).then(function (res) {
          if (!res.ok) throw new Error("CLEAR_CART_FAILED");
          window.location.reload();
        }).catch(function (error) {
          console.error("[BBB Clear Cart]", error);
          yesButton.disabled = false;
          window.alert("Unable to clear cart right now.");
        });
        return;
      }

      if (!event.target.closest("[data-bbb-cart-more]")) {
        closeCartMoreMenus();
      }
    });
  }

  function bindShareButtons() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest(".share-cart-button,[data-share-cart-button]");
      if (!button) return;

      event.preventDefault();
      generateShareLink(button);
    });
  }

  function runInsertedScripts(root) {
    Array.prototype.slice.call(root.querySelectorAll("script")).forEach(function (script) {
      var nextScript = document.createElement("script");
      Array.prototype.slice.call(script.attributes).forEach(function (attribute) {
        nextScript.setAttribute(attribute.name, attribute.value);
      });
      nextScript.text = script.text || script.textContent || "";
      script.parentNode.replaceChild(nextScript, script);
    });
  }

  function installQuoteFallback(attempt) {
    if (document.querySelector("[data-bbb-cart-quote-request]") || document.querySelector("[data-bbb-quote-cart-action]")) {
      return;
    }

    var shareControl = document.querySelector("[data-share-cart-button], .share-cart-button");
    var shareRow = shareControl && shareControl.closest ? shareControl.closest(".cart-share-row") : null;
    if (!shareRow) {
      if ((attempt || 0) < 8) {
        window.setTimeout(function () {
          installQuoteFallback((attempt || 0) + 1);
        }, 300);
      }
      return;
    }

    var root = document.createElement("div");
    root.className = "cart-recap__quote-request";
    root.setAttribute("data-bbb-cart-quote-request", "");
    root.style.marginTop = "18px";
    shareRow.insertAdjacentElement("afterend", root);

    fetch("/apps/quote-request/embed", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Quote embed is not available.");
        return response.text();
      })
      .then(function (html) {
        root.innerHTML = html;
        runInsertedScripts(root);
      })
      .catch(function () {
        root.innerHTML = '<a class="button button--secondary button--full" href="/apps/quote-request">Request quotation</a>';
      });
  }

  function init() {
    bindCartMoreMenus();
    bindShareButtons();
    installQuoteFallback();
    ensureModal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
